// @ts-ignore
/* eslint-disable */
// import { request } from '@umijs/max';
import request from '../../requestInstance';
import { CommonResult } from '../CommonType';

/** 获取当前的用户 GET /api/currentAccount */
export async function currentAccount(options?: { [key: string]: any }) {
  return request<CommonResult<API.CurrentAccount>>('/api/currentAccount', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 刷新token POST /api/refresh-token */
export async function refreshToken(options?: { [key: string]: any }) {
  return request<CommonResult<void>>('/api/refresh-token', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<CommonResult<void>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function accountLogin(body: API.AccountLoginParams, options?: { [key: string]: any }) {
  return request<CommonResult<API.LoginResult>>('/api/login/account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/mobile */
export async function mobileLogin(body: API.AccountLoginParams, options?: { [key: string]: any }) {
  return request<CommonResult<API.LoginResult>>('/api/login/mobile', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/sns */
export async function snsLogin(body: API.AccountLoginParams, options?: { [key: string]: any }) {
  return request<CommonResult<API.LoginResult>>('/api/login/sns', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

/** 发送邮件 POST /api/auth/send-email-code */
export async function sendEmail(body: { email: string }, options?: { [key: string]: any }) {
  return request<CommonResult<void>>('/api/auth/send-email-code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 邮箱登录接口 POST /api/auth/email-login */
export async function emailLogin(
  body: { email: string; captcha: string },
  options?: { [key: string]: any },
) {
  return request<CommonResult<API.LoginResult>>('/api/login/email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
